import { pluralizeWithCount } from "@common/helpers/string";

interface FormatSelectionSummaryParams {
    selectedCount: number;
    singleLabel: string | undefined;
    noun: string;
}

export function formatSelectionSummary({
    selectedCount,
    singleLabel,
    noun,
}: FormatSelectionSummaryParams): string {
    if (selectedCount === 1 && singleLabel) {
        return singleLabel;
    }
    return pluralizeWithCount(noun, selectedCount);
}
